<template>
  <div v-if="user">
    <div :class="{ 'form-group': label, 'has-error': showError }">
      <div class="col-lg-4" v-if="label">
        <label class="control-label">{{ label }}</label>
      </div>
      <div :class="{ 'col-lg-8': label }">
        <div class="input-group">
          <input v-model="registration" type="text" class="form-control" />
          <span class="input-group-btn">
            <form-button
              level="primary"
              @clicked="search"
              :indicator="searching"
            >
              Search Fleet
            </form-button>
          </span>
        </div>

        <p class="text-danger" v-if="showError" v-text="errorMessage"></p>

        <template v-if="vehicles.length">
          <p style="margin-top: 10px;">
            We found multiple vehicles with that registration, please select the
            correct vehicle:
          </p>

          <select
            name="result_id"
            class="form-control"
            @input="selectResult($event.target.value)"
          >
            <option value="">Please Select</option>
            <option
              :key="vehicleIndex"
              :value="vehicle.id"
              v-for="(vehicle, vehicleIndex) in vehicles"
            >
              {{ vehicle.registration }}
            </option>
          </select>
        </template>
      </div>
    </div>

    <div v-if="result">
      <div class="alert alert-info">
        <div class="row">
          <div class="col-lg-4">
            <label class="control-label">
              Make
            </label>
          </div>
          <div class="col-lg-8">
            {{ result.make?.label }}
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4">
            <label class="control-label">
              Model
            </label>
          </div>
          <div class="col-lg-8">
            {{ result.model }}
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4">
            <label class="control-label">
              ABI Group
            </label>
          </div>
          <div class="col-lg-8">
            {{ result.group?.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: {
      required: true
    },
    vehicle: {
      type: Object
    },
    errorMessage: {
      type: String
    },
    showError: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      registration: null,
      result: null,
      vehicles: [],
      searching: false
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  mounted() {
    this.setVehicle(this.vehicle);
  },

  methods: {
    search() {
      let identifier = this.user.tenant?.identifier;

      if (identifier) {
        this.searching = true;

        window.Ajax.get(
          `/fleet/${identifier}?filter[terms]=${this.registration}`
        )
          .then(({ data }) => {
            if (data.length) {
              if (data.length === 1) {
                this.setResult(data[0]);
              } else {
                this.result = null;
                this.vehicles = data;
              }
            } else {
              window.toastify.error('Error', 'Vehicle not found');
            }

            this.searching = false;
          })
          .catch(() => {
            window.toastify.error(
              'Error',
              'An error occurred while searching for the vehicle'
            );

            this.searching = false;
          });
      }
    },

    setVehicle(vehicle) {
      if (vehicle) {
        this.registration = vehicle.registration;
        this.result = vehicle;
      }
    },

    selectResult(id) {
      const vehicle = this.vehicles.find(vehicle => vehicle.id == id);

      if (vehicle) {
        this.setResult(vehicle);
      }
    },

    setResult(vehicle) {
      this.result = vehicle;
      this.registration = vehicle.registration;
      this.vehicles = [];

      this.$emit('input', vehicle.id);
    }
  },

  watch: {
    vehicle(vehicle) {
      this.setVehicle(vehicle);
    }
  }
};
</script>
